import { render, staticRenderFns } from "./IcoArrowOutUpRectangle.vue?vue&type=template&id=5917b44a"
import script from "./IcoArrowOutUpRectangle.vue?vue&type=script&lang=js"
export * from "./IcoArrowOutUpRectangle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports